import {Request} from '../classes/request';

/** DNS (1) e DNS + Iperammortamento 4.0 (6). Esclude DNS + 4.0 e DNS + 5.0. */
export const DNS_SABATINI_TYPE_IDS = [1, 6];

/** Vista Domanda Nuova Sabatini: solo pratiche Completate di quei due tipi. */
export function isDnsSabatiniViewRequest(request: Pick<Request, 'FKIDRequestType' | 'ProgressStatus'>): boolean {
    return DNS_SABATINI_TYPE_IDS.includes(Number(request.FKIDRequestType))
        && Number(request.ProgressStatus) === 10;
}

export const STAMP_PROBLEM_LABEL = 'Marca da bollo non inserita';
export const PARTICIPATION_PROBLEM_LABEL = 'Società partecipata, redigere prospetto';
export const CUP_PROBLEM_LABEL = 'Codice CUP non inserito o non inviato';
export const PHASE1_PROBLEM_OPTIONS = ['Sì', 'No'] as const;
export const STAMP_PROBLEM_OPTIONS = [STAMP_PROBLEM_LABEL, PARTICIPATION_PROBLEM_LABEL];
export const CUP_PROBLEM_OPTIONS = [CUP_PROBLEM_LABEL];
export const PRACTICE_PHASE_FILTER_OPTIONS = ['Fase 1', 'Fase 2'];

export function hasFilledValue(value: unknown): boolean {
    if (value === null || value === undefined) {
        return false;
    }
    if (typeof value === 'string') {
        return value.trim().length > 0;
    }
    return true;
}

export function hasStampProblem(request: Request): boolean {
    return !hasFilledValue(request.RevenueStamp);
}

export function hasParticipationProblem(request: Request): boolean {
    return request.CompanyParticipation === true || request.PartnersParticipation === true;
}

export function hasCupProblem(request: Request): boolean {
    return !hasFilledValue(request.CUPCode)
        || !hasFilledValue(request.CUPCodePECSentDate)
        || !hasFilledValue(request.CUPCodeEmailSentDate);
}

export function hasPhase1Problem(request: Request): boolean {
    return hasStampProblem(request) || hasParticipationProblem(request);
}

export type PracticePhase = 1 | 2;

/** Fase 2 solo se non ci sono problemi in sottofase 1 né in sottofase 2. */
export function practicePhase(request: Request): PracticePhase {
    return !hasPhase1Problem(request) && !hasCupProblem(request) ? 2 : 1;
}

export function practicePhaseLabel(request: Request): string {
    return `Fase ${practicePhase(request)}`;
}

export function stampProblemLabel(request: Request): string {
    return hasStampProblem(request) ? STAMP_PROBLEM_LABEL : '';
}

export function participationProblemLabel(request: Request): string {
    return hasParticipationProblem(request) ? PARTICIPATION_PROBLEM_LABEL : '';
}

export function phase1ProblemLabels(request: Request): string[] {
    const labels: string[] = [];
    const stamp = stampProblemLabel(request);
    if (stamp) {
        labels.push(stamp);
    }
    const participation = participationProblemLabel(request);
    if (participation) {
        labels.push(participation);
    }
    return labels;
}

export function cupProblemLabel(request: Request): string {
    return hasCupProblem(request) ? CUP_PROBLEM_LABEL : '';
}

export function practiceFolderName(request: Request): string {
    const vat = (request.customer?.VATNumber || request.VATNumber || '').trim();
    if (!vat || request.IDRequest == null) {
        return '';
    }
    return `${vat}_${request.IDRequest}`;
}
